<script setup>
// REQ-20260824-04: show Meta default-app guidance when hop_v2 is not true.
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import FacebookRoutingStatusAPI from '../api';

const props = defineProps({
  inboxId: { type: [String, Number], default: null },
});

const { t } = useI18n();

const loaded = ref(false);
const hopV2 = ref(null);

const showGuide = computed(() => loaded.value && hopV2.value !== true);

const loadStatus = async () => {
  loaded.value = false;
  hopV2.value = null;
  if (!props.inboxId) {
    loaded.value = true;
    hopV2.value = false;
    return;
  }

  try {
    const { data } = await FacebookRoutingStatusAPI.getStatus(props.inboxId);
    hopV2.value = data?.hop_v2 === true;
  } catch {
    hopV2.value = false;
  } finally {
    loaded.value = true;
  }
};

watch(() => props.inboxId, loadStatus, { immediate: true });
</script>

<template>
  <div
    v-if="showGuide"
    class="rounded-xl border border-n-amber-4 bg-n-amber-3 text-n-amber-11 text-sm p-4"
  >
    <p class="font-medium text-n-slate-12">
      {{ t('CUSTOM.MESSENGER_ROUTING.TITLE') }}
    </p>
    <p class="mt-2">
      {{ t('CUSTOM.MESSENGER_ROUTING.INTRO') }}
    </p>
    <ol class="mt-3 list-decimal space-y-1 pl-5">
      <li>{{ t('CUSTOM.MESSENGER_ROUTING.STEP_1') }}</li>
      <li>{{ t('CUSTOM.MESSENGER_ROUTING.STEP_2') }}</li>
      <li>{{ t('CUSTOM.MESSENGER_ROUTING.STEP_3') }}</li>
      <li>{{ t('CUSTOM.MESSENGER_ROUTING.STEP_4') }}</li>
    </ol>
    <p class="mt-3 text-xs text-n-slate-11">
      {{ t('CUSTOM.MESSENGER_ROUTING.SKIP_NOTE') }}
    </p>
  </div>
</template>
